<template>
    <div class="ei-right-bar">
        <div>hahaha</div>
    </div>
</template>

<script>
export default {
    name: 'EiRightBar',
    mounted() {
        //window.addEventListener('mousewheel', this.handleScroll, true) || window.addEventListener('DOMMouseScroll', this.handleScroll, false)
        window.addEventListener("scroll", this.handleScroll, true)
    },
    methods: {
        handleScroll() {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            console.log(scrollTop);
        }
    }
}
</script>

<style scope>
.ei-right-bar{
    position: fixed;
    right: 30px;
    bottom: 100px;
}
</style>